<app-information-on-construction
  *ngIf="firingSystemData"
  [firingSystemData]="firingSystemData"
  [isReadOnly]="isReadOnly"></app-information-on-construction>
<app-exhaust-system-data
  *ngIf="firingSystemData"
  [firingSystemData]="firingSystemData"
  [isReadOnly]="isReadOnly"
  [applicationId]="applicationId"
  [isDetailsView]="isDetailsView"></app-exhaust-system-data>
<app-fireplace-ventilation-system
  *ngIf="firingSystemData"
  [firingSystemData]="firingSystemData"
  [furnaceData]="furnaceData"
  [isReadOnly]="isReadOnly"
  [applicationId]="applicationId"
  [isDetailsView]="isDetailsView"></app-fireplace-ventilation-system>
<app-releases
  *ngIf="firingSystemData"
  [firingSystemData]="firingSystemData"
  [isReadOnly]="isReadOnly"
  [applicationId]="applicationId"
  [isDetailsView]="isDetailsView"></app-releases>
<app-information-on-meter-installation
  *ngIf="environmentService.showMeterInstallation && currentFlowType === installationFlowType.NewInstallation && firingSystemData"
  [firingSystemData]="firingSystemData"
  [isReadOnly]="isReadOnly"
  [applicationId]="applicationId"
  [isDetailsView]="isDetailsView"></app-information-on-meter-installation>
